import { render, staticRenderFns } from "./auto-message-faq.vue?vue&type=template&id=91e5502e&"
import script from "./auto-message-faq.vue?vue&type=script&lang=js&"
export * from "./auto-message-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports